import {
  getCurrentPeriod,
  getPeriodEndIso,
  getPeriodStartIso,
  PeriodRangePreset,
} from '@asset-metrix/portal-ui';
import { TFunction } from 'i18next';

export function getMonthRangePresets(
  t: TFunction,
  now?: Date
): PeriodRangePreset[] {
  const current = () => now ?? new Date();

  return [
    {
      label: t('app.pageFilter.monthRangeFilter.presets.qtd'),
      value: () => {
        const at = current();
        return {
          start: getPeriodStartIso(getCurrentPeriod('quarter', at), 'quarter'),
          end: getPeriodEndIso(getCurrentPeriod('month', at), 'month'),
        };
      },
    },
    {
      label: t('app.pageFilter.monthRangeFilter.presets.ytd'),
      value: () => {
        const currentMonth = getCurrentPeriod('month', current());
        return {
          start: getPeriodStartIso(
            { year: currentMonth.year, period: 1 },
            'month'
          ),
          end: getPeriodEndIso(currentMonth, 'month'),
        };
      },
    },
    {
      label: t('app.pageFilter.monthRangeFilter.presets.sinceInception'),
      value: () => ({
        end: getPeriodEndIso(getCurrentPeriod('month', current()), 'month'),
      }),
    },
  ];
}
